/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLivestockAnimalWeightHistoryQueryResponse, GetLivestockAnimalWeightHistoryPathParams, GetLivestockAnimalWeightHistory400, GetLivestockAnimalWeightHistory401, GetLivestockAnimalWeightHistory403, GetLivestockAnimalWeightHistory404, GetLivestockAnimalWeightHistory409, GetLivestockAnimalWeightHistory500 } from "../../types/livestockController/GetLivestockAnimalWeightHistory.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLivestockAnimalWeightHistory } from "../../client/livestockController/getLivestockAnimalWeightHistory.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLivestockAnimalWeightHistoryQueryKey = (organizationId: GetLivestockAnimalWeightHistoryPathParams["organizationId"] | undefined, animalId: GetLivestockAnimalWeightHistoryPathParams["animalId"] | undefined) => [{ url: '/api/organizations/:organizationId/livestock/animals/:animalId/weight-history', params: {organizationId:organizationId,animalId:animalId} }] as const

export type GetLivestockAnimalWeightHistoryQueryKey = ReturnType<typeof getLivestockAnimalWeightHistoryQueryKey>

export function getLivestockAnimalWeightHistoryQueryOptions(organizationId: GetLivestockAnimalWeightHistoryPathParams["organizationId"] | undefined, animalId: GetLivestockAnimalWeightHistoryPathParams["animalId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLivestockAnimalWeightHistoryQueryKey(organizationId, animalId)
        return queryOptions<GetLivestockAnimalWeightHistoryQueryResponse, ResponseErrorConfig<GetLivestockAnimalWeightHistory400 | GetLivestockAnimalWeightHistory401 | GetLivestockAnimalWeightHistory403 | GetLivestockAnimalWeightHistory404 | GetLivestockAnimalWeightHistory409 | GetLivestockAnimalWeightHistory500>, GetLivestockAnimalWeightHistoryQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && animalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLivestockAnimalWeightHistory(organizationId!, animalId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Weight history for an animal: every weighing, GMD windows (incl. lifetime), arroba/carcass estimate, herd-target projection, lot rank and weaning
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId/weight-history}
 */
export function useGetLivestockAnimalWeightHistory<TData = GetLivestockAnimalWeightHistoryQueryResponse, TQueryData = GetLivestockAnimalWeightHistoryQueryResponse, TQueryKey extends QueryKey = GetLivestockAnimalWeightHistoryQueryKey>(organizationId: GetLivestockAnimalWeightHistoryPathParams["organizationId"] | undefined, animalId: GetLivestockAnimalWeightHistoryPathParams["animalId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetLivestockAnimalWeightHistoryQueryResponse, ResponseErrorConfig<GetLivestockAnimalWeightHistory400 | GetLivestockAnimalWeightHistory401 | GetLivestockAnimalWeightHistory403 | GetLivestockAnimalWeightHistory404 | GetLivestockAnimalWeightHistory409 | GetLivestockAnimalWeightHistory500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLivestockAnimalWeightHistoryQueryKey(organizationId, animalId)
         

         const query = useQuery({
          ...getLivestockAnimalWeightHistoryQueryOptions(organizationId, animalId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLivestockAnimalWeightHistory400 | GetLivestockAnimalWeightHistory401 | GetLivestockAnimalWeightHistory403 | GetLivestockAnimalWeightHistory404 | GetLivestockAnimalWeightHistory409 | GetLivestockAnimalWeightHistory500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}